import Vue from "vue";
import VueI18n, { LocaleMessages } from "vue-i18n";

Vue.use(VueI18n);

const messages: LocaleMessages = {
    en: {
        localeName: "en_US",
        studio: {
            notfound:
                "Studio not found. If this problem persists, press CTRL+F5 to refresh this page.",
            onleave: "Do you really want to leave?",
            close: "Close",
            participant: "Participants",
            invite: "Send Invite",
            validTo: "Quick Link valid to...",
            createInvitation: "Create Invitation Code",
            add: "Add",
            validCodes: "Currently valid Codes",
            copyToClipboard: "Copied id to clipboard!",
            addStudio: "Add Studio",
            removeWarn:
                "This will permanently remove the Studio and all associated events and registriations related to it.",
            removeBtn: "Yes",
            abort: "Cancel",
            overallReport: "Create report for all studios",
            studioManagerSubtitle: `Create new Studios for different audiences, as breakout rooms or for different purposes like permanent Download-Centers.`,
            editLabel: "Studio Name",
            properties: "Properties",
            deleteError: "You can not delete studios with participants",
            connectionLost: "Connection Lost",
            reconnect: "reconnect",
            reconnected: "Reconnected",
            required: "Required",
            protectedTitle: "Protected Studio",
            protected:
                "This studio is only accessible for authorized persons. Please enter your email you used for registration.",
            joinProtected: "Enter studio",
            blocked:
                "You cannot enter this studio, because you are not registered for this event.",
            tooManyParticipants: "Too many participants {participants}/{max}",
            toggleFullscreen: "Toggle Fullscreen",
            hideToolbar: "Hide",
            showToolbar: "Toolbar",
            page: "Page {i}/{n}",
            nextPage: "Next Page",
            previousPage: "PreviousPage",
            manager: {
                headline: `Edit Studio: {name}`,
                editStudioName: "Edit studio name",
                csvOnly: "Please upload a .csv file!",
                accessControl: "Activate access control",
                addedList: "{listType} successfully updated.",
                nameUpdated: "Studio name changed to: {newName}",
                clearLists: "Clear both lists",
                uploadListsDescription:
                    "Upload CSV Files to restrict the access to this studio.",
                exampleFile: "Example file",
                showJoinLeave: "Show join/leave notification",
                showJoinLeaveTooltip:
                    "If deactivated, other participants won't see when others join or leave the studio.",
                backgroundLabel: "Background Image",
                backgroundUpdated: "Background Image updated",
                backgroundRemoved: "Background Image removed",
                backgroundRemoveHeader: "Remove Background?",
                backgroundError: "Background change failed",
                backgroundSize: "Background size",
                backgroundPosition: "Background position",
                userLikeChatActive: "Include Userlike Chat",
            },
            specialSignUp: {
                eventRegistration: "Event registration",
                eventRegistrationDescription:
                    "You are not registered for this event, but you can participate after filling out this form:",
                email: "Email",
                name: "Name",
                surName: "Surname",
                zip: "ZIP",
                company: "Company",
                disclaimer:
                    "By signing up you agree to our terms of service and data protection policy.",
                subscriber: "Subscribe to the event organistor's newsletter",
            },
        },
        home: {
            welcome: "VIBRIX",
            studioInput: "Enter Quick Connect Code",
            joinBtn: "Join",
            signup: "Sign Up",
            twoWeektrial: "* 14 Days free test-period",
            buyPremium: "Get VIBRIX",
            whyVibrix: "Why VIBRIX?",
            whatIsVibrix: "What is VIBRIX?",
            vibrixDescription: `VIBRIX is a cloud presentation tool that closes the gap between real-life sessions and videoconferencing.
                VIBRIX is your simple and intuitive platform whenever you get in contact with your customers, seminar participants or your team online.
                Focus on your contents and your audience, get them involved with the built-in, easy-to-use tools and start selling more, teaching better
                and presenting smarter!`,

            liveInteractionTitle: "Sell faster",
            liveInteraction: `Achieve unprecedented involvement using the live interaction tools. 
                You can manage the contents your audience sees in the browser in real time. 
                The contents are always displayed in crystal clear quality - independently from your viewers' internet connection speed, so you can
                present your product from it's best side to convince your customers faster.`,

            directCommunication: `Get faster and better results in your workshops and seminars. Your audience does not need additional software -
                everything works from the web browser.
                Join a meeting within seconds by using our 4-digit Quick-Connect-Code. You can also use VIBRIX as an auxilary tool for telephone conferencing and ad-hoc meetings.`,
            directCommunicationTitle: "Be a better coach",

            ownTools: `VIBRIX has simplicity in mind. Regardless of the tools or formats you use for creating your content: 
                Our 1-click Import function creates a VIBRIX presentation from PowerPoint, PDF, Word, or other files.`,
            ownToolsTitle: "Bring Your Tools",

            saveTime: `Minimize your preparation time and follow-up work by using the download center for sharing documents, meeting results or whatever fits your usecase. 
                Analyse your sessions with meaningful reports.`,
            saveTimeTitle: "More time for the next customer",
        },
        tools: {
            surveyDescription: `Create quick surveys to get instant feedback from your audience. 
                Use it to steer your presentation into the right direction or let the crowd decide how they liked your presentation.   
                You decide how the results are shared. Display them for everybody or keep them private.`,
            surveyTitle: `Surveys`,

            downloaderDescription: `File sharing has never been easier. Drag and drop multiple files and they become directly accessible for your audience. 
                You can also request files from your audience. Skip distributing PowerPoints, PDFs and screenshots via E-Mail after your presentation - just make your important files available in the download center!`,
            downloaderTitle: "Download Center",

            whiteBoardDescription: `Work and sketch together in realtime! You prepared worksheets in PowerPoint? 
                Just import your presentation with the 1-Click-Import and VIBRIX will create a whiteboard for every slide.`,
            whiteBoardTitle: "Collaborative Whiteboard",

            chatDescription: `Receive questions, let participants discuss or get feedback. Add and remove the chat widget with one click depending on your needs.`,
            chatTitle: "Group & Moderator Chat",

            vcDescription: `Crystal clear Video Conferencing whenevener you need it. Dynamically place any other widget next to the videcoonference and enjoy the flexible layout possibilities.
                            You can also directly share your screen with up to 60 Frames per seond for a lag free experience.`,
            vcTitle: "Video Conferencing",

            scriptBuilderTitle: "",
            scriptBuilderDescription: "",
            studioManagerDescription: `In VIBRIX you give your presentations inside studios. These are much like "breakout-rooms" you know from other software
            but you can have as many as you like and can use them in parallel. So you could use one dedicated studio for a Downloadcenter,
            or have different groups work in different studios.`,
            studioManagerTitle: "Studios",
            markdownTitle: "Texteditor",
            markdownDescription:
                "Use a versatile live-text editing tool with markdown support. Create customized and meaningful content.",
            plyrTitle: "Pre-recorded webinars and videos",
            plyrDescription:
                "Upload your pre-recorded seminars to a studio for lossless quality. Participants will experience as if your presentation was LIVE. With VIBRIX you won't have to worry about your internet connection or weak hardware.",
            accessrightsTitle: "Access Rights",
            accessrightsDescription:
                "Control precisely who is allowed to join your studio, who is not allowed and who has to sign up. You can target single email addresses or use wildcards for complete domains.",
        },
        test: {
            intro: `You're interested in VIBRIX? Register now for the limited testing programme!
            Give us your feedback on what you like and dislike and which features you want to see in the future. 
            Become an active part in the development process and help shaping VIBRIX to be the tool you always wanted!
            As a reward you will have unlimited access to VIBRIX after the test period.`,
            becomeTester: "Become a tester in 3 quick steps!",
            step1: "Register and create an account.",
            step2: "Tell us about your usecase.",
            step3: "We upgrade your account to premium.",
            problems: "Already registered? Login & Refresh this page.",
            question1:
                "Do you use any other videoconferencing Tool? If so, what are the shortcomings?",
            question2: "Please describe shortly what you will use VIBRIX for.",
            question3: "What is your profession?",
            question4: "How big is your audience on average?",
            question5:
                "How often per week do you intend to use VIBRIX/Other Videoconference tools?",
            question6:
                "How many people are working in your company? (est. Headcount)",
            submit: "Submit",
            waitForMailTitle: "Done!",
            waitForMail:
                "Thank you! Soon you will receive an email which confirms your participation in the testing programme! After that you can start testing.",
        },
        login: {
            login: "log in",
            logout: "log out",
        },
        navigation: {
            notLoggedIn: "not logged in",
            home: "Home",
            script: "Script Manager",
            studios: "Studio Manager",
            profile: "Profile",
            reports: "Report Manager",
            events: "Event Manager",
        },
        widget: {
            draw: {
                colorSelect: "Select Color",
                drawMode: "Draw",
                dragMode: "Drag",
                textMode: "Add Text",
                download: "Download",
                upload: "Upload picture",
                delete: "Delete content",
                colorPicker: "Color Picker",
                brushSize: "Brush size: {size}px",
                selectedColor: "Selected Color: {color}",
                mode: "Mode: {mode}",
                mouseWheelZoom: "Mousewheel for zoom ({zoom})%",
                textCreator: "Text Settings",
                textSize: "Text size",
                textAdd: "Add following text",
                confirmDelete: "This will erase all content! Proceed?",
                autoFitMissing: "Please select an object first.",
                enableAutoFit: "AutoFit",
                autoFitDescription:
                    "Scale everything so that it fits in the widget",
                drawLock: "Lock Whiteboard",
                drawLockDescription:
                    "Other participants cannot edit the whiteboard",
            },
            chat: {
                inputLabel: "Say something...",
                groupChat: "Group chat",
                privateChat: "Moderator chat",
                privateChatDescription:
                    "Participants can only write to the presenter",
                promote: "Promote",
                promotedUserChat:
                    "Sie sind Co-Moderator:in und können mit Teilnehmern chatten",
            },
            delete: {
                title: "Delete widget?",
                question: "Are you sure you want to remove this widget?",
                button: "Yes",
                cancel: "Cancel",
            },
            jitsi: {
                muteMic: "Mute Microphone",
                muted: "Your mic is muted, others won't hear you",
                actMic: "Activate Microphone",
                stopVideo: "Stop Video",
                startVideo: "Start Video",
                startShare: "Start Screensharing",
                stopShare: "Stop Screensharing",
                muteAll: "Mute all",
                startConference: "Start Video Conference",
                endConference: "End Video Conference",
                warnStart:
                    "Start the conference so other participants can see you",
                lobby: "Activate Lobby",
                lobbyDescription:
                    "You need to approve every joining participant",
                waitForStart:
                    "Please wait until the presenter starts the videocall...",
            },
            radio: {
                addOption: "Add",
                option: "New Option",
                placeholer: "Add another answer...",
                title: "Title",
                titleUpdated: "Title updated",
                previewBtnLabel: "Preview",
                previewBtnLabelStop: "Stop Preview",
                showResults: "Show Results",
                showResultsTooltip:
                    "Currently other participants CAN see the results",
                hideResultsTooltip:
                    "Currently other participants CANNOT see the results",
                answerGiven: "Save answer",
                answerSaved: "Answer saved",
                answerButtonTitle: "Answer Button",
                answerButtonDescription:
                    "Participants can see a 'Save Answer Button', which closes the survey",
                thanks: "Thank you for your answer!",
            },
            fileAgent: {
                layoutList: "List Layout",
                layoutGrid: "Grid Layout",
                helpText: "Choose file or Drag & Drop",
                title: "Title",
                titleUpdated: "Title updated",
                maxFiles: "Max. Files: ",
                maxSize: "Maxi. File size: ",
                allowGuestUpload: "Allow Guest Upload",
                delete: "Delete File?",
            },
            plyr: {
                live: "To live-{mediaType}",
                uploadHintVideo: "{accept} videos",
                uploadInstructionsVideo:
                    "Please add an Suffix (480p, 720p, 1080p) to your filename e.g. my_video720p.webm so that your viewers can choose the quality.",
                uploadHintAudio: "choose an audio file",
                uploadNamingError:
                    "Missing Suffix (480p, 720p, 1080p, audio) in the filename",
                upload: `Upload {number} file(s)`,
                uploadLimits: "Upload 1 file with up to 1GB",
                createMedia: "Create Media Player",
                enterTitle: "Please enter a title",
                optionUpload: "Upload",
                optionChoose: "Choose existing media file",
                mediaSelect: "Own videos",
                mediaSelectItemText: `{title} (from {script}, page {page})`,
                muted: "Audio is muted",
                delete: "Delete File?",
                deleteCloudflareDescription:
                    "All scripts/studios/reports won't be able to use this file anymore",
                qualitySettings: "Quality",
                encoding:
                    "Video encoding in progress, this may take some minutes. Full quality will be ready shortly after encoding is finished. You may have to refresh the page.",
                encodingStatus: "Current Step: {step}",
                encodingError: "Error processing file. Check the file format",
                allowFullscreen: "Allow Fullscreen",
                allowAutoplay: "Allow Autoplay",

                firewalled:
                    "Connection blocked by Firewall/Adblocker/DNS, starting alternative...",
                videoBlocked:
                    "You have an Adblocker enabled - this could cause playback problems.",
                help: `Please make sure that: <ul>
                    <li>You use a modern webbrowser (Chrome, Firefox, Edge)</li>
                    <li>You are not connected to a VPN</li>
                    <li>You are not using an adblocker/li>
                    <li>Your (company) network is supporting videostreams and websockets</li>
                    </ul>`,
            },
            markdown: {
                allowEdit: "Everybody can edit",
                preview: "Preview",
                saved: "Text Saved",
                instruction:
                    "# Usage\n\nPress CTRL+S or the save button to save the text and send it to other participants",
            },
        },
        script: {
            load: "Load script",
            loadWarningHeader: "Warning",
            loadWarningText:
                "A script is already loaded. Loading another Script may alter the current presentation and reports.",
            save: "Save script",
            cancel: "Cancel",
            delete: "Delete script",
            deleteConfirm: "Are you sure you want to delete the script?",
            refresh: "Refresh scripts",
            entername: "Enter script name...",
            back: "Back",
            differentName: "Filename exists too often, please rename file!",
            tooLarge: "The File is too large! (Max. 10MB)",
            new: "Create new script",
            page: {
                deleteTitle: "Delete?",
                delete: "Are you sure you want to delete this page?",
                deleteYes: "Delete",
                deleteNo: "Cancel",
            },
            widgetId: "ID: {id} (hint for reusing widgets)",
            widgetSize: "width:{w} height:{h}",
            bar: {
                load: "Load",
                save: "Save",
                import: "Import",
            },
            manager: "Script Manager",
            managerDescription:
                "Create a new script, edit existing ones or create a script from uploading a file!",
        },
        guest: {
            title: "Guest Login",
            username: {
                invalid: "Please use less than 255 characters",
            },
            email: {
                invalid: "Please enter a valid email address",
            },
            snackbar: {
                close: "Close",
            },
            loginAsGuest: "Continue as Guest",
            loginRegister: "Login / Register",
        },
        profile: {
            property: "Property",
            value: "Value",
            displayNameUpdate: "Update Displayname",
            displayNameLabel: "Displayname",
            displayNameUpdated: "Displayname Updated",
            description: "Check your profile and manage your subscription.",
            subscription: "Subscription",
            validTo: "Next payment",
            endSubscription: "End subscription",
            confirmEndSubscription:
                "Are you sure you want to end your subscription?",
            cancel: "No i will stay",
            ok: "Unsubscribe",
            invoice: "Invoice Number",
            invoiceDate: "Invoice Date",
            noInvoice: "No Invoice available yet.",
            download: "Download Invoice",
            userLikeChatDescription:
                "Insert your Userlike Chatwidget 'Secret' here. Then you can use the Userlike-Chat in studios and scripts.",
            userLikeChatUpdated: "Userlikechat activated.",
            userLikeChatUpdatedError: "Invalid Userlike Secret",
        },
        pricing: {
            headline: "Pricing",
            personalTitle: "Personal Licence",
            personalPricing: `Billed monthly, can be terminated anytime`,
            personalDescription: `Use all VIBRIX features without any limits`,
            enterpriseTitle: "Enterprise Subscription",
            enterpriseDescription: `You want to use VIBRIX within your company? We would like to give you an individual offer!`,
            onPremiseTitle: "On-Premise Installation",
            onPremiseDescription: `You want to host VIBRIX on your own hardware or in your datacenter? That's possible!
            Get in contact with us to get more information about the implementation!`,
            mailSales: "Mail us!",
            callSales: "Or call us!",
            priceFormat: "{price} € / month",
        },
        header: {
            home: "Home",
            test: "Test",
            tools: "Tools",
            pricing: "Pricing",
        },
        report: {
            enterName: "Enter Report Name",
            description: "Save the current state of the presentation",
            manager: "Report Manager",
            managerDescription:
                "View all saved reports and create new scripts from saved sessions!",
            delete: "Delete",
            deleteHeader: "Delete Report?",
            deleteQuestion: "This will permanently erase the saved state",
            open: "Open",
            saved: "Saved current state as report.",
            download: "Download",
            downloadStarted: "Download started...",
            howTo:
                "click the report symbol in a studio to create your first report!",
        },
        event: {
            managerDescription: "Create scheduled events in your studios",
            createFormTitle: "Create new Event",
            createCalendarLink: "Create Calendar Link",
            title: "Title",
            startDate: "Start",
            endDate: "End",
            duration: "Duration",
            selectStudio: "Select Studio",
            private: "Private (events will not be shown in public calendar)",
            description: "Description",
            joinDescription: "Join Description",
            setDescriptionBtn: "Set Description",
            setJoinDescriptionBtn: "Set Join Description",
            setEmailTemplatesBtn: "Change emails",
            mailTemplateTexts: {
                registerEmailTemplate: "Thanks for registering for the event!",
                reminderEmailTemplate: "The event will start soon!",
                cancelEmailTemplate: "The event was cancelled.",
                followupEmailJoinedTemplate: "Thanks for your participantion!",
                followupEmailNoShowTemplate:
                    "We hope to see you next time around!",
                registerEmailLabel: "Text for the email after registration",
                reminderEmailLabel:
                    "Text for thw Reminder Email (1h before start)",
                cancelEmailTLabel: "Text for event cancellation",
                followupEmailJoinedLabel:
                    "Text for Follow-Up Email (participated, 1h after event ended)",
                followupEmailNoShowLabel:
                    "Text for Follow-Up Email (not participated, 1h after event ended)",
            },
            cancelBtn: "Cancel",
            createEventBtn: "Create Event",
            closeEditor: "Ok",
            back: "Back to Overview",
            registrations: "Registered participants",
            maxRegistrations: "Max. Registrations",
            maxRegistrationHint:
                "If the maximum is reached, the message 'Event-Full' is shown.",
            isFullDescriptionButton: "Set text for full event",
            eventFullAlert: "This event is fully booked",
            noLimit: "No limit",
            fullName: "Name",
            signup: {
                email: "Email",
                name: "Name",
                lastname: "Lastname",
                registrationId: "Id",
                company: "Company",
                zip: "Zip-Code",
                phone: "Telephone",
                joined_event: "Participated",
                source: "Referrer",
            },
            toSignup: "signup",
            error: {
                over: "Event is already over!",
                blocked: "Cannot register for event.",
            },
            signUpCompleteHdr: "Registration complete!",
            signUpComplete:
                "Thank you for your registration. You will soon receive an email with further information. Please also check your Spam-Folder. You can also download the calendar entry for this event here.",
            calendarEntry: "Download calendar entry",
            updated: "Event updated",
            copyToClipboard: "Link copied to Clipboard",
            register: "Register for {eventName}",
            submitRegistration: "Register for Event",
            submittedRegistration: "Registered successfully for Event",
            deleteRegistration: "Block / Allow",
            copyLinkLabel: "Link to register for the event",
            copyCalendarLabel: "Link to your public calendar",
            calendarLinkDescription:
                "Create a link to share your public calendar(only events that are set to 'public'appear). The link leads directly to the selected month.",
            upcomingEvents: "Upcoming Events",
            iAmNot: "I am not {user}",
            invitationlist: "Invitation List",
            blockList: "Blocklist",
            blockListExplanation: `User on the blocklist cannot register again for this event.
            Furthermore they cannot join this event with the link they got in their confirmation mail. 
            The blocklist acts as an addtional filter together with the studio filter.`,
            invitationlistExplanation: `[Not implemented]. Here you can upload a CSV file with email addresses. All users get notified about the invitation and they can signup for this event.`,

            actions: "Open",
            deleteBtn: "Delete Event",
            delete:
                "This action will delete the event as well as the registrations and will inform the registered participants.",
            deleted: "Event deleted",

            form: {
                duration: "Min. : 0, Max: 180",
            },
            refresh: "Refresh",
            blocklistBlocked: "The registration is invalid.",
            report: "Eventreport saved",
            malformedLink: "Link is invalid or malformed - check your URL",
            nextMonth: "Next Month",
            prevMonth: "Previous month",
        },
    },
    de: {
        localeName: "de_DE",
        studio: {
            notfound:
                "Studio konnte nicht gefunden werden. Wenn dieses Problem weiter besteht, drücken Sie STRG+F5 um die Seite zu aktualisieren.",
            onleave: "Studio verlassen?",
            close: "Schließen",
            participant: "Teilnehmer",
            invite: "Einladung",
            validTo: "Einladung gültig bis...",
            createInvitation: "Einladungscode erstellen",
            add: "Erstellen",
            validCodes: "Gültige Codes",
            copyToClipboard: "Code in Zwischenablage kopiert!",
            addStudio: "Neues Studio",
            removeWarn:
                "Dieses Studio dauerhaft entfernen? Diese Aktion löscht alle Events und Registrierungen, die mit diesem Studio verbunden sind.",
            removeBtn: "Ja",
            overallReport: "Report für alle Studios erstellen",
            abort: "Abbrechen",
            editLabel: "Studio Name",
            properties: "Einstellungen",
            deleteError: "Löschen von Studios mit Teilnehmern nicht möglich.",
            studioManagerSubtitle: `Erstelle neue Studios für verschiedene Zielgruppen, als "Breakout-rooms" oder für andere Zwecke wie z.B. permanente Download-Center.`,
            connectionLost: "Verbindung verloren",
            reconnect: "Neu verbinden",
            reconnected: "Verbindung wiederhergestellt",
            required: "Pflichtfeld",
            protectedTitle: "Geschütztes Studio",
            protected:
                "Nur autorisierte Personen haben Zugriff auf dieses Studio. Bitte geben Sie die E-Mail an, mit der Sie sich registriert haben.",
            joinProtected: "Beitreten",
            blocked:
                "Sie können dieses Studio nicht betreten, da Sie nicht für dieses Event registriert sind.",
            tooManyParticipants: "Zu viele Teilnehmer {participants}/{max}",
            toggleFullscreen: "Vollbild an/aus",
            hideToolbar: "Ausblenden",
            showToolbar: "Toolbar",
            page: "Seite {i}/{n}",
            nextPage: "Nächste Seite",
            previousPage: "Vorherige Seite",
            manager: {
                headline: `Studio bearbeiten: {name}`,
                editStudioName: "Studionamen ändern",
                csvOnly: "Bitte eine .csv Datei wählen!",
                accessControl: "Zugangsbeschränkung aktivieren",
                addedList: "{listType} erfolgreich aktualisiert.",
                nameUpdated: "Studioname geändert zu: {newName}",
                clearLists: "Beide Listen löschen",
                uploadListsDescription:
                    "Lade CSV Dateien hoch um den Zugang zum Studio zu beschränken.",
                exampleFile: "Beispieldatei",
                showJoinLeave: "Beitrittsbenachrichtigungen anzeigen",
                showJoinLeaveTooltip:
                    "Wenn deaktiviert: Teilnehmer sehen nicht mehr wenn andere Teilnehmer das Studio betreten oder verlassen.",
                backgroundLabel: "Hintergrundbild",
                backgroundUpdated: "Hintergrundbild geändert",
                backgroundRemoved: "Hintergrundbild entfernt",
                backgroundRemoveHeader: "Hintergrund entfernen?",
                backgroundError: "Hintergrund ändern fehlgeschlagen",
                backgroundSize: "Hintergrundgröße",
                backgroundPosition: "Hintergrundposition",
                userLikeChatActive: "Userlike Chat integrieren",
            },
            specialSignUp: {
                eventRegistration: "Event Registrierung",
                eventRegistrationDescription:
                    "Sie sind nicht für dieses Event registriert, können aber nach Angabe folgender Daten teilnehmen:",
                email: "Email",
                name: "Vorname",
                surName: "Nachname",
                zip: "PLZ",
                company: "Firma",
                disclaimer:
                    "Mit der Anmeldung akzeptieren Sie die Nutzungsbedingungen und die Datenschutzvereinbarung",
                subscriber: "Newsletter des Veranstalters abonnieren",
            },
        },
        home: {
            welcome: "VIBRIX",
            studioInput: "Quick Connect Code eingeben",
            joinBtn: "Beitreten",
            signup: "Registrieren",
            twoWeektrial: "* Testen Sie 14 Tage kostenlos",
            buyPremium: "Abonniere VIBRIX",
            whyVibrix: "Warum VIBRIX?",
            whatIsVibrix: "Was ist VIBRIX?",
            vibrixDescription: `VIBRIX ist eine Cloud-Präsentationssoftware, die die Lücke zwischen Präsenzveranstaltungen und Videokonferenzen schließt.
                                VIBRIX ist Ihre simple und intuitive Plattform sobald Sie mit Kunden, Seminarteilnehmern oder Ihrem Team online in Kontakt treten.
                                Fokussieren Sie sich auf Ihre Inhalte und Ihr Publikum, involvieren Sie sie mit den einfach zu bedienenden, integrierten Präsentationstools 
                                und fangen Sie an mehr zu verkaufen, bessere Schulungen zu geben und smarter zu präsentieren!`,

            liveInteraction: `Binden Sie Ihre Zuhörer in Ihre Online-Präsentation ein wie noch nie zuvor. 
            Kontrollieren Sie die Inhalte, die ihr Publikum sieht, direkt im Browser. 
            Dabei spielt die Internetverbindung keine Rolle, die Inhalte werden immer gut lesbar und in voller Qualität dargestellt.`,
            liveInteractionTitle: "Verkaufen Sie schneller",

            directCommunication: `Erzielen Sie schnellere und bessere Ergebnisse in Workshops und Seminaren. 
            Ihr Publikum braucht keine spezielle Software - alles funktioniert im Browser.
            Treten Sie einem VIBRIX-Meeting mit unserem 4-stelligen Quick Connect Code bei. 
            Sie können VIBRIX auch als ergänzendes Tool für Telefonkonferenzen oder Präsenzmeetings nutzen.`,
            directCommunicationTitle: "Seien Sie ein besserer Trainer",

            ownTools: `VIBRIX fokussiert sich auf Einfachheit. Egal mit welchem Programm Sie Ihre Inhalte erstellen: Verwenden Sie den 1-Klick-Import, um Ihre Inhalte aus PowerPoint, PDF, 
            Word oder anderen Formaten in eine VIBRIX Präsentation umzuwandeln.`,
            ownToolsTitle: "Mit gewohnten Programmen arbeiten",

            saveTime: `Minimieren Sie die für Vor- und Nachbereitung benötigte Zeit, indem Sie alle relevanten Dokumente 
            und Ergebnisse des Meetings im Downloadportal zur Verfügung stellen. Analysieren Sie den Verlauf ihrer 
            Schulungen mit aussagekräftigen Reports.`,
            saveTimeTitle: "Mehr Zeit für Ihren nächsten Kunden",
        },
        tools: {
            surveyDescription: `Erstellen Sie schnelle Umfragen und erhalten Sie sofortiges Feedback von Ihren Zuhörern. 
                Lenken Sie Ihre Präsentation in die richtige Richtung oder holen Sich sich Rückmeldung, wie Ihren Zuhörern die Präsentation gefallen hat.
                Sie können selbst entscheiden, ob oder wie die Ergebnisse der Umfrage geteilt werden. Zeigen Sie die Ergebnisse für alle an, oder nur für sich selbst.`,
            surveyTitle: `Umfragen`,

            downloaderDescription: `Dateien austauschen war noch nie einfacher. Ziehen Sie Dateien per Drag & Drop in die Präsentation und sie werden sofort für alle Teilnehmer verfügbar.
                        Genauso einfach können ihre Zuhörer auch Dateien für Sie hochladen. Sparen Sie sich die Zeit im Nachgang Dokumente und Folien per E-Mail zu verschicken.
                        Stellen Sie stattdessen die Dateien direkt in der Präsentation in einem kleinen Downloadcenter zur Verfügung!`,
            downloaderTitle: "Download Center",

            whiteBoardDescription: `Arbeiten und zeichnen sie ohne Verzögerung zusammen! Sie haben bereits eine Präsentation in PowerPoint vorbereitet? 
                Importieren Sie diese einfach mit dem 1-Klick Import und VIBRIX generiert aus jeder Folie ein eigenes Whiteboard auf dem Sie zusammen mit ihren Zuhörern arbeiten können.`,
            whiteBoardTitle: "Kollaboratives Whiteboard",

            chatDescription: `Sammeln Sie Fragen, bieten sie Teilnehmern die Möglichkeit zur Diskussion oder erhalten sie sofort Feedback. Fügen Sie mit nur einem Klick so viele Chats wie nötig in Ihre Präsentation ein.`,
            chatTitle: "Moderatoren- & Gruppenchat",

            vcDescription: `Video Konferenzen in höchster Qualität, wann immer Sie sie brauchen. Platzieren sie jedes andere Widget neben die Video Konferenz und profitieren Sie von flexiblen Layouts.
                            Natürlich können sie auch ihren Bildschirm teilen und das mit bis zu 60 Bildern pro Sekunde - für ein ruckelfreies Präsentieren.`,
            vcTitle: "Video Konferenz",

            scriptBuilderTitle: "",
            scriptBuilderDescription: "",

            studioManagerDescription: `In VIBRIX halten Sie Ihre Präsentationen in Studios. Diese ähneln den "Breakout-Rooms" anderer Programme,
                    allerdings können Sie beliebig viele Studios anlegen und parallel benutzen. So könnte ein Studio als permanentes Downloadcenter dienen,
                    oder sie können Gruppen in verschiedenen Räumen arbeiten lassen.`,
            studioManagerTitle: "Studios",
            markdownTitle: "Texteditor",
            markdownDescription:
                "Verwenden Sie den Live-Texteditor um Inhalte zu erstellen und zu teilen. Dank des Markdown Supports, können Sie flexibel vielfältige Inhalte darstellen.",
            plyrTitle: "Aufgezeichnete Webinare und Videos",
            plyrDescription:
                "Zeichnen Sie Ihre Webinare auf und binden Sie diese in bester Qualität in Ihre Studios ein. Für die Teilnehmer sieht es so aus als wäre die Präsentation LIVE. Mit VIBRIX müssen Sie sich keine Gedanken über Ihre Internetgeschwindigkeit oder schwache Hardware machen.",
            accessrightsTitle: "Zugangskontrolle",
            accessrightsDescription:
                "Kontrollieren sie präzise wer ihr Studio betreten kann, wer geblockt ist und wer sich für einen Zugang registrieren muss. Hierbei können Sie einzelne E-Mail Adressen angeben oder auch komplette Domains.",
        },
        test: {
            intro: `Sie sind interessiert an VIBRIX? Registrieren Sie sich jetzt für das limitierte Test-Programm!
            Geben Sie uns Feedback zu den Funktionen die Sie mögen, nicht mögen und in der Zukunft gerne sehen würden. 
            Werden Sie zum aktiven Teil in der Entwicklung und helfen Sie die Software zu kreieren, die Sie schon immer wollten!
            Als Dankeschön können Sie VIBRIX für ein Jahr nach dem Test uneingeschränkt weiter nutzen.`,
            becomeTester: "Werden Sie in 3 Schritten zum Tester",
            step1: "Registrieren Sie sich.",
            step2: "Erzählen Sie uns etwas über Ihren Anwendungsfall",
            step3: "Wir schalten Ihnen alle Funktionen frei.",
            problems: "Schon registriert? Login & Seite aktualisieren.",
            question1:
                "Verwenden Sie zur Zeit ein anderes Videokonferenztool? Wenn ja, was stört Sie daran?",
            question2: "Beschreiben Sie kurz wozu Sie Vibrix einsetzen werden.",
            question3: "Was ist ihr Beruf?",
            question4: "Wie groß ist ihr Publikum im Schnitt?",
            question5:
                "Wie oft in der Woche planen sie VIBRIX/Andere Videokonferenzsysteme zu nutzen",
            question6:
                "Wie viele Mitarbeiter arbeiten in ihrer Firma (Schätzung)?",
            submit: "Absenden",
            waitForMailTitle: "Fertig!",
            waitForMail:
                "Vielen Dank! In Kürze erhalten Sie eine Bestätungsemail. Danach können Sie anfangen VIBRIX zu testen.",
        },

        login: {
            login: "Anmelden",
            logout: "Abmelden",
        },
        navigation: {
            notLoggedIn: "Nicht angemeldet",
            home: "Startseite",
            script: "Skript Manager",
            studios: "Studio Manager",
            profile: "Profil",
            reports: "Report Manager",
            events: "Event Manager",
        },
        widget: {
            draw: {
                colorSelect: "Farbe auswählen",
                drawMode: "Zeichnen",
                dragMode: "Verschieben",
                textMode: "Text hinzufügen",
                download: "Herunterladen",
                upload: "Bild hochladen",
                delete: "Inhalt löschen",
                colorPicker: "Farbauswahl",
                brushSize: "Pinselgröße: {size}px",
                selectedColor: "Ausgewählte Farbe: {color}",
                mode: "Modus: {mode}",
                mouseWheelZoom: "Mausrad zum Zoomen ({zoom}%)",
                textCreator: "Text Einstellungen",
                textSize: "Textgröße",
                textAdd: "Text hinzufügen",
                confirmDelete: "Diese Aktion enfernt alle Inhalte! Fortfahren?",
                autoFitMissing: "Bitte erst ein Objekt auswählen.",
                enableAutoFit: "AutoFit",
                autoFitDescription:
                    "Inhalte so skalieren, damit sie in das Widget passen.",
                drawLock: "Whiteboard sperren",
                drawLockDescription:
                    "Andere Teilnehmer können das Whiteboard nicht bearbeiten",
            },
            chat: {
                inputLabel: "Schreiben Sie eine Nachricht..",
                groupChat: "Gruppenchat",
                privateChat: "Moderatorenchat",
                privateChatDescription:
                    "Ihre Nachrichten gehen ausschließlich an die Moderator:innen",
                promote: "Promote",
                promotedUserChat:
                    "Sie sind Co-Moderator:in und können mit Teilnehmern chatten",
            },
            delete: {
                title: "Widget löschen?",
                question:
                    "Sind Sie sicher, dass Sie dieses Widget löschen wollen?",
                button: "Ja",
                cancel: "Nein",
            },
            jitsi: {
                muteMic: "Mikrofon stummschalten",
                muted: "Ihr Mikrofon ist aus. Andere hören sie nicht.",
                actMic: "Mikron einschalten",
                stopVideo: "Kamera ein",
                startVideo: "Kamera aus",
                startShare: "Bildschirm freigeben",
                stopShare: "Bildschirm nicht freigeben",
                muteAll: "Alle stummschalten",
                startConference: "Videokonferenz starten",
                endConference: "Videokonferenz beenden",
                warnStart:
                    "Andere Personen können Sie nicht sehen, starten sie dazu die Konferenz",
                lobby: "Lobby aktivieren",
                lobbyDescription:
                    "Sie müssen den Beitritt jedes Teilnehmers genehmigen",
                waitForStart:
                    "Bitten warten sie bis der Präsentator die Videokonferenz startet...",
            },
            radio: {
                addOption: "Hinzufügen",
                option: "Neue Option",
                placeholer: "Eine weitere Antwort...",
                title: "Titel",
                titleUpdated: "Titel geändert",
                previewBtnLabel: "Vorschau",
                previewBtnLabelStop: "Vorschau beenden",
                showResults: "Ergebnisse anzeigen",
                showResultsTooltip:
                    "Aktuell KÖNNEN andere Teilnehmer die Ergebnisse sehen",
                hideResultsTooltip:
                    "Aktuell können andere Teilnehmer die Ergebnisse NICHT sehen",
                answerGiven: "Antwort speichern",
                answerSaved: "Antwort gespeichert",
                answerButtonTitle: "Antwort Button",
                answerButtonDescription:
                    "Teilnehmer sehen einen 'Antwort speichern' Button, mit dem sie die Umfrage abschließen können.",
                thanks: "Danke für Ihre Antwort!",
            },
            fileAgent: {
                layoutList: "Listenansicht",
                layoutGrid: "Kachelansicht",
                helpText: "Datei auswählen oder Drag & Drop",
                title: "Titel",
                titleUpdated: "Titel geändert",
                maxFiles: "Maximale Anzahl Dateien: ",
                maxSize: "Maximale Dateigröße: ",
                allowGuestUpload: "Jeder kann hochladen",
                delete: "Datei löschen?",
            },
            plyr: {
                live: "Zum Live-{mediaType}",
                uploadHintVideo: "{accept} Videos auswählen",
                uploadHintAudio: "Audio Datei auswählen",

                uploadInstructionsVideo: `Bitte füge einen der folgenden Begriffe an den Dateinamen an: (480p, 720p, 1080p), z.B. mein_video720p.webm, damit deine Zuschauer die Qualität einstellen können.`,
                uploadNamingError:
                    "Fehlendes Suffix (480p, 720p, 1080p) im Dateinamen",
                upload: `{number} Datei(en) hochladen`,
                uploadLimits: "1 Datei mit max. 1GB",
                createMedia: "Mediaplayer erstellen",
                enterTitle: "Bitte einen Titel angeben",
                optionUpload: "Hochladen",
                optionChoose: "Bestehendes Medium wählen",
                mediaSelect: "Eigene Medien",
                mediaSelectItemText: `{title} (von {script}, Seite {page})`,
                muted: "Audio ist stummgeschaltet",
                delete: "Datei löschen?",
                deleteCloudflareDescription:
                    "Alle Scripts/Studios/Reports werden dieses Video nicht mehr verwenden können.",
                qualitySettings: "Qualität",
                encodingStatus: "Aktueller Schritt: {step}",
                encoding:
                    "Video Verarbeitung gestartet. Dies könnte einige Minuten dauern. Das Video wird kurze Zeit nach der Verarbeitung in höchster Qualität zur Verfügung stehen. Möglicherweise muss die Seite aktualisiert werden.",
                encodingError:
                    "Fehler bei Verarbeitung, bitte Dateiformat prüfen.",
                allowFullscreen: "Vollbild zulassen",
                allowAutoplay: "Autoplay aktivieren",

                firewalled:
                    "Verbindung durch Firewall/Adblocker/DNS blockiert, starte Alternative...",
                videoBlocked:
                    "Adblocker aktiv! Dies könnte die Wiedergabe blockieren.",
                help: `Bitte stellen Sie sicher, dass: 
                    <ul>
                        <li>Sie einen aktuellen Desktopbrowser verwenden (Chrome, Firefox, Edge)</li>
                        <li>Sie nicht mit einem VPN verbunden sind</li>
                        <li>Sie keinen Adblocker aktiviert haben</li>
                        <li>Ihr Netzwerk (im Firmenumfeld) Videostreams & Websockets unterstützt</li>
                    </ul>
                    Sollte das Problem weiterbestehen, aktualisieren Sie die Seite mit dem gleichzeitigen drücken von STRG+F5 oder 
                    öffnen Sie einen Browser im "Inkognito"-Modus und ohne Erweiterungen und versuchen Sie den Beitritt erneut.
                    `,
            },
            markdown: {
                allowEdit: "Jeder kann bearbeiten",
                preview: "Vorschau",
                saved: "Text gespeichert",
                instruction:
                    "# Benutzung\n\nSTRG+S oder Save Button drücken um den Text zu speichern.",
            },
        },
        script: {
            load: "Skript laden",
            loadWarningHeader: "Achtung",
            loadWarningText:
                "Es ist bereits ein Skript geladen. Report Daten können verloren gehen. Fortfahren?",
            save: "Skript speichern",
            cancel: "Abbrechen",
            delete: "Skript löschen",
            deleteConfirm: "Bist du sicher, dass du das Skript löschen willst?",
            refresh: "Skripte aktualisieren",
            entername: "Name eingeben...",
            back: "Zurück",
            differentName: "Name existiert zu häufig, bitte Datei umbenennen!",
            tooLarge: "Die Datei ist zu groß! (Max. 10MB)",
            new: "Neues Skript anlegen",
            page: {
                deleteTitle: "Löschen?",
                delete:
                    "Sind Sie sicher, dass Sie diese Seite löschen möchten?",
                deleteYes: "Löschen",
                deleteNo: "Abbrechen",
            },
            widgetId: "ID: {id} (für 'reuse widget')",
            widgetSize: "Breite:{w} Höhe:{h}",
            bar: {
                load: "Laden",
                save: "Speichern",
                import: "Import",
            },
            manager: "Skript Manager",
            managerDescription:
                "Erstelle ein neues Skript, bearbeite ein bestehendes oder erstelle eines aus einer hochgeladenen Datei!",
        },
        guest: {
            title: "Login als Gast",
            username: {
                invalid: "Bitte benutzen Sie weniger als 255 Zeichen",
            },
            email: {
                invalid: "Bitte geben Sie eine gültige E-Mail Adresse an",
            },
            loginAsGuest: "Weiter als Gast",
            loginRegister: "Login / Registrieren",
            snackbar: {
                close: "Ok",
            },
        },
        profile: {
            property: "Eigenschaft",
            value: "Wert",
            displayNameUpdate: "Anzeigenamen ändern",
            displayNameLabel: "Anzeigename",
            displayNameUpdated: "Anzeigename geändert",
            description: "Verwalten Sie ihr Profil und ihr Abonnement.",
            subscription: "Abo",
            validTo: "Nächste Verlängerung",
            endSubscription: "Abo beenden",
            confirmEndSubscription:
                "Bist du sicher, dass du das Abonnement beenden willst?",
            cancel: "Nein, ich bleibe",
            ok: "Abo beenden",
            invoice: "Rechnungsnummer",
            invoiceDate: "Rechnungsdatum",
            noInvoice: "Noch keine Rechnung vorhanden.",
            download: "Rechnung herunterladen",
            userLikeChatDescription:
                "Füge hier dein Userlike Chatwidget 'Secret' ein. Danach kannst du den Userlike-Chat in Studios und Skripten aktivieren",
            userLikeChatUpdated: "Userlike Chat aktiviert.",
            userLikeChatUpdatedError: "Ungültiges Userlike Secret",
        },
        pricing: {
            headline: "Preise",
            personalTitle: "Persönliche Lizenz",
            personalPricing: `Monatliche Abrechnung, jederzeit kündbar`,
            personalDescription: `Nutze alle VIBRIX Features unbegrenzt`,
            enterpriseTitle: "Enterprise Abo",
            enterpriseDescription: `Sie möchten VIBRIX gerne für Ihre ganze Firma einsetzen? Gerne machen wir Ihnen dafür ein individuelles Angebot!`,
            onPremiseTitle: "On-Premise Installation",
            onPremiseDescription: `Sie möchten VIBRIX gerne auf Ihrer eigenen Hardware oder im eigenen Rechenzentrum hosten? Das ist möglich!
            Setzen Sie sich mit uns in Verbindung, um sich über die Möglichkeiten zu informieren!`,
            mailSales: "Mailen Sie uns!",
            callSales: "Oder rufen Sie an!",
            priceFormat: "{price} € / Monat",
        },
        header: {
            home: "Home",
            test: "Test",
            tools: "Tools",
            pricing: "Preise",
        },
        report: {
            enterName: "Report Namen angeben",
            description: "Den aktuellen Stand der Präsentation speichern",
            manager: "Report Manager",
            managerDescription:
                "Alle Reports anzeigen und neue Skripts basierend auf gespeicherten Sessions anlegen!",
            delete: "Löschen",
            deleteHeader: "Report Löschen?",
            deleteQuestion: "Das wird den Report permanent löschen",
            open: "Öffnen",
            saved: "Aktueller Stand als Report gespeichert",
            download: "Download",
            downloadStarted: "Download wird gestartet...",
            howTo:
                "Klicke auf das Report Symbol in einem Studio um deinen ersten Report zu erstellen!",
        },
        event: {
            managerDescription: "Events verwalten und anlegen",
            createFormTitle: "Neues Event anlegen",
            createCalendarLink: "Kalenderlink erstellen",
            title: "Titel",
            startDate: "Start",
            endDate: "Ende",
            duration: "Dauer",
            selectStudio: "Studio auswählen",
            private: "Privat (Events werden nicht im Kalender angezeigt)",
            description: "Event Beschreibung",
            joinDescription: "Warteraum Beschreibung",
            setDescriptionBtn: "Beschreibung ändern",
            setJoinDescriptionBtn: "Beschreibung für Warteraum ändern",
            setEmailTemplatesBtn: "Emails bearbeiten",
            mailTemplateTexts: {
                registerEmailTemplate:
                    "Vielen Dank für die Registrierung zum Event",
                reminderEmailTemplate: "Das Event fängt gleich an!",
                cancelEmailTemplate: "Das Event wurde abgesagt.",
                followupEmailJoinedTemplate:
                    "Vielen Dank für die Teilnahme am Event!",
                followupEmailNoShowTemplate:
                    "Schade, dass Sie nicht teilnehmen konnten!",
                registerEmailLabel: "Text für die Registrierungsemail",
                reminderEmailLabel:
                    "Text für die Reminder Email (1h vor Beginn)",
                cancelEmailLabel: "Text für Eventabsage",
                followupEmailJoinedLabel:
                    "Text für Follow-Up Email (teilgenommen, 1h nach Event-Ende)",
                followupEmailNoShowLabel:
                    "Text für Follow-Up Email (nicht teilgenommen, 1h nach Event-Ende)",
            },
            cancelBtn: "Abbrechen",
            createEventBtn: "Event anlegen",
            closeEditor: "Ok",
            back: "Zurück zur Übersicht",
            registrations: "Registrierte Teilnehmer",
            maxRegistrations: "Maximale Teilnehmerzahl",
            maxRegistrationHint:
                "Wenn die maximale Teilnehmerzahl erreicht ist, können sich keine weiteren Teilnehmer mehr anmelden und die Nachricht 'Event voll' wird angezeigt.",
            isFullDescriptionButton: "Beschreibung für volle Events ändern",
            eventFullAlert: "Dieses Event ist ausgebucht",
            noLimit: "Kein Limit",
            fullName: "Name",
            signup: {
                email: "Email",
                name: "Vorname",
                lastname: "Nachname",
                registrationId: "Id",
                company: "Firma",
                zip: "Postleitzahl",
                phone: "Telefon",
                joined_event: "Teilgenommen",
                source: "Referrer",
            },
            toSignup: "Anmelden",
            error: {
                over: "Event ist bereits vorbei!",
                blocked: "Registrierung nicht mehr möglich.",
            },
            signUpCompleteHdr: "Registrierung erfolgreich!",
            signUpComplete:
                "Vielen Dank für die Registrierung. Sie erhalten in Kürze eine E-Mail mit weiteren Informationen. Prüfen Sie bitte auch Ihren Spam-Ordner. Sie können den Kalendereintrag für das Event hier herunterladen",
            calendarEntry: "Kalendereintrag speichern",
            updated: "Event aktualisiert",
            copyToClipboard: "Link in Zwischenablage kopiert",
            register: "Anmeldung für {eventName}",
            submitRegistration: "Anmelden",
            submittedRegistration: "Erfolgreich für das Event angemeldet",
            deleteRegistration: "Blocken / Entsperren",
            copyLinkLabel: "Link zur Registrierungsseite für das Event",
            copyCalendarLabel: "Link zu deinem öffentlichen Kalender",
            calendarLinkDescription:
                "Erstelle einen Link zum Teilen deines öffentlichen Kalenders (nur Events die auf 'public' gestellt sind erscheinen). Der Link führt direkt zu dem ausgewählten Monat.",
            upcomingEvents: "Anstehende Events",
            iAmNot: "Ich bin nicht {user}",
            invitationlist: "Einladungsliste",
            blockList: "Blockliste",
            blockListExplanation: `User auf der Blockliste können sich nicht erneut für dieses Event registrieren.
                Zusätzlich können blockierte Nutzer einem Event (mit dem Link aus Bestätigungsemail) nicht beitreten. 
                Die Blockliste aus Events fungiert als zusätzlicher Filter zur Studio-Blockliste, die weiterhin aktiv sein kann.`,
            invitationlistExplanation: `[Noch nicht implementiert]. Hier kann eine CSV Datei mit E-Mail-Adressen hochgeladen werden. Alle User werden über die Einladung benachrichtigt und erhalten einen Link zur Evenregistrierung.`,
            actions: "Öffnen",
            deleteBtn: "Event löschen",
            deleted: "Event gelöscht",
            delete:
                "Diese Aktion wird das Event sowie die Registrierungen löschen und die registrierten Teilnehmer darüber informieren",
            form: {
                duration: "Min. : 0, Max: 180",
            },
            refresh: "Aktualisieren",
            blocklistBlocked: "Die Registrierung ist ungültig.",
            report: "Eventreport gespeichert",
            malformedLink: "Link ist ungültig oder defekt - prüfen Sie die URL",
            nextMonth: "Nächster Monat",
            prevMonth: "Vorheriger Monat",
        },
    },
};

export default new VueI18n({
    messages,
    locale: navigator.language.substring(0, 2),
    fallbackLocale: "de",
    silentFallbackWarn: true,
});
